module.exports = __webpack_public_path__ + "static/media/goalsdashboard.2ab52d0c.png";